
import React, { Component } from 'react';


class GeneralPractitioner extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    render() {
        var data = this.props.data;
        return <React.Fragment>
            {data && data.name &&
                <div className="mb-4">
                    <div><b>Huisarts:</b></div>
                    <div>{data.name}</div>
                    {data.phone &&
                        <React.Fragment>
                            <i className="fa-solid fa-phone"></i> {data.phone}
                        </React.Fragment>
                    }
                </div>
            }
        </React.Fragment>
    }

}


export default GeneralPractitioner;